// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1Q-8L","DesktopOnly":"Toolbar_DesktopOnly__2nShd"};